import { CSSProperties } from 'react';

// Renders the glance headline's `**bold**` segments — plain text otherwise (no
// full markdown), shared by the desktop and mobile Morning Brief cards.

export function BriefHeadline({ text, boldStyle }: { text: string; boldStyle: CSSProperties }) {
  const segments = text.split('**');
  return (
    <>
      {segments.map((segment, i) =>
        i % 2 === 1 ? (
          <strong key={i} style={boldStyle}>
            {segment}
          </strong>
        ) : (
          <span key={i}>{segment}</span>
        ),
      )}
    </>
  );
}
